/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Open_TitleInputs */

const en_pc_online_task_open_title = /** @type {(inputs: Pc_Online_Task_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open a PDF`)
};

const zh_pc_online_task_open_title = /** @type {(inputs: Pc_Online_Task_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 PDF`)
};

/**
* | output |
* | --- |
* | "Open a PDF" |
*
* @param {Pc_Online_Task_Open_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_open_title = /** @type {((inputs?: Pc_Online_Task_Open_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Open_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_open_title(inputs)
	return zh_pc_online_task_open_title(inputs)
});
export { pc_online_task_open_title as "pc.online.task.open.title" }